import { graphql } from 'react-relay';

export const PageInfoFragment = graphql`
    fragment PageInfoFragment on PageInfo {
        count
    }
`;
